import axios from "axios";

axios.defaults.baseURL =
  process.env.NODE_ENV === "development"
    ? "/api"
    : "https://api.karentarabarnet.com/api";

// axios.defaults.headers.post["Content-Type"] = "application/json";
// axios.defaults.timeout = 8000;
axios.defaults.headers.common["X-CSRFToken"] = ``;

export const fetcher = (url: any[]) =>
  axios
    .get(url[0], {
      headers: {
        Authorization: url[1] && `Bearer ${url[1]}`,
      },
    })
    .then((res) => res.data);

export const fetcherPost = (url: any[], { arg }: { arg: any }) =>
  axios
    .post(url[0], arg, {
      headers: {
        Authorization: url[1] && `Bearer ${url[1]}`,
        ...url[2],
      },
      ...url[3],
    })
    .then((res) => res.data);
